var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "g-pesquisa",
        {
          ref: "refResultadoPesquisaRequerente",
          attrs: {
            id: "refResultadoPesquisaRequerente",
            name: "refResultadoPesquisaRequerente",
            filtroAdicional: _vm.getFiltroPesquisa,
            limparFiltroLocal: _vm.limparFiltro,
            colunasPropriedade: _vm.colunasRequerentesDataTable,
            apiPesquisa: _vm.apiRequerente,
            operacoes: _vm.operacoes,
            exibirColunaOperacoes: _vm.exibirColunaOperacoes,
            elementosPorPagina: _vm.elementosPorPagina,
            imprimir: _vm.imprimir,
            novo: _vm.novoItem,
            showCardPesquisa: true,
            showBuscaAvancada: true,
            showBuscaAvancadaAberta: true,
            showTermoPesquisa: false,
            carregamentoInicial: false,
            showBotaoNovo: _vm.permissaoPerfil.incluir
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-7 col-xs-7" },
              [
                _c("g-autocomplete", {
                  ref: "refRequerente",
                  attrs: {
                    id: "refRequerente",
                    name: "refRequerente",
                    etiqueta: "Requerente",
                    valor: "nomRequerente",
                    foco: false,
                    descricaoPrimaria: "nomeDataNascimentoDocumento",
                    desabilitar: _vm.paginaStatus.desabilitarEdicao,
                    api: _vm.apiRequerente
                  },
                  model: {
                    value: _vm.requerente.nomRequerente,
                    callback: function($$v) {
                      _vm.$set(_vm.requerente, "nomRequerente", $$v)
                    },
                    expression: "requerente.nomRequerente"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-sm-3 col-xs-3",
                staticStyle: { "padding-left": "5px" }
              },
              [
                _c("g-dateInput", {
                  ref: "refDataNascimento",
                  attrs: {
                    id: "refDataNascimento",
                    name: "refDataNascimento",
                    etiqueta: "Data de Nascimento",
                    desabilitar: false,
                    somenteLeitura: _vm.paginaStatus.desabilitarEdicao
                  },
                  model: {
                    value: _vm.requerente.dataNascimento,
                    callback: function($$v) {
                      _vm.$set(_vm.requerente, "dataNascimento", $$v)
                    },
                    expression: "requerente.dataNascimento"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-4 col-xs-4" },
              [
                _c("g-select", {
                  ref: "refTipoDocumento",
                  attrs: {
                    id: "refTipoDocumento",
                    name: "refTipoDocumento",
                    etiqueta: "Tipo de Documento",
                    itens: _vm.documentoArray,
                    "item-valor": "codigo",
                    "item-etiqueta": "descricao",
                    foco: false,
                    desabilitar: _vm.paginaStatus.desabilitarEdicao
                  },
                  model: {
                    value: _vm.tipoDocumento,
                    callback: function($$v) {
                      _vm.tipoDocumento = $$v
                    },
                    expression: "tipoDocumento"
                  }
                })
              ],
              1
            ),
            _vm.tipoDocumento === "CPF"
              ? _c(
                  "div",
                  { staticClass: "col-sm-6 col-xs-6" },
                  [
                    _c("g-input", {
                      ref: "refTxtDocumento",
                      attrs: {
                        id: "refTxtDocumento",
                        name: "refTxtDocumento",
                        tipo: "text",
                        etiqueta: "CPF",
                        mascara: "cpf",
                        tamanho: 20,
                        foco: false,
                        chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina,
                        desabilitar:
                          _vm.tipoDocumento == null ||
                          _vm.tipoDocumento == "" ||
                          _vm.paginaStatus.desabilitarEdicao
                      },
                      model: {
                        value: _vm.requerente.txtDocumento,
                        callback: function($$v) {
                          _vm.$set(_vm.requerente, "txtDocumento", $$v)
                        },
                        expression: "requerente.txtDocumento"
                      }
                    })
                  ],
                  1
                )
              : _vm.tipoDocumento === "CNP"
                ? _c(
                    "div",
                    { staticClass: "col-sm-6 col-xs-6" },
                    [
                      _c("g-input", {
                        ref: "refTxtDocumento",
                        attrs: {
                          id: "refTxtDocumento",
                          name: "refTxtDocumento",
                          tipo: "text",
                          etiqueta: "CNPJ",
                          mascara: "cnpj",
                          tamanho: 20,
                          foco: false,
                          chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina,
                          desabilitar:
                            _vm.tipoDocumento == null ||
                            _vm.tipoDocumento == "" ||
                            _vm.paginaStatus.desabilitarEdicao,
                          "converter-para-maiusculo": true
                        },
                        model: {
                          value: _vm.requerente.txtDocumento,
                          callback: function($$v) {
                            _vm.$set(_vm.requerente, "txtDocumento", $$v)
                          },
                          expression: "requerente.txtDocumento"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "col-sm-6 col-xs-6" },
                    [
                      _c("g-input", {
                        ref: "refTxtDocumento",
                        attrs: {
                          id: "refTxtDocumento",
                          name: "refTxtDocumento",
                          tipo: "text",
                          etiqueta: "Documento",
                          tamanho: 20,
                          foco: false,
                          chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina,
                          desabilitar:
                            _vm.tipoDocumento == null ||
                            _vm.tipoDocumento == "" ||
                            _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.requerente.txtDocumento,
                          callback: function($$v) {
                            _vm.$set(_vm.requerente, "txtDocumento", $$v)
                          },
                          expression: "requerente.txtDocumento"
                        }
                      })
                    ],
                    1
                  )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }